import type { ButtonPassThroughMethodOptions } from "primevue/button";
import type { DialogPassThroughMethodOptions } from "primevue/dialog";
import type { DropdownPassThroughMethodOptions } from "primevue/dropdown";
import Lara from "@/presets/lara";
import type { BadgeState } from "./types";

export const addOnRequestsPresets = {
  dropdown: {
    ...Lara.dropdown,
    root: (options: DropdownPassThroughMethodOptions<unknown>) => ({
      class: [...Lara.dropdown.root(options).class, "!w-full md:!w-52 !h-11"],
    }),
  },
  accordionTab: {
    root: { class: "!mb-0" },
    header: { class: "!normal-case !font-normal" },
    headerAction: {
      class: [
        "flex flex-wrap items-center gap-3 !bg-warning-100 px-6 py-4 border-b border-gray-175 rounded-t-lg",
        "cursor-pointer select-none",
      ],
    },
    content: { class: "!p-0 !border-0 !bg-transparent !rounded-none" },
  },
  primaryButton: {
    ...Lara.button,
    root: (options: ButtonPassThroughMethodOptions<unknown>) => ({
      class: [
        ...Lara.button.root(options).class,
        "whitespace-nowrap !text-15p !font-semibold !bg-teal-900 !border-teal-900",
        "hover:!bg-teal-700 hover:!border-teal-700",
      ],
    }),
  },
  outlinedTealButton: {
    ...Lara.button,
    root: (options: ButtonPassThroughMethodOptions<unknown>) => ({
      class: [
        ...Lara.button.root(options).class,
        "whitespace-nowrap !text-15p !font-semibold !bg-white !text-teal-900 !border-teal-900",
        "hover:!bg-teal-light",
      ],
    }),
  },
};

// Shared by AddOnStatusChangeModal and AddOnConfirmAddModal.
export const addOnModalDialogPt = {
  ...Lara.dialog,
  root: (options: DialogPassThroughMethodOptions<unknown>) => ({
    class: [...Lara.dialog.root(options).class, "!overflow-hidden !rounded-lg"],
  }),
  footer: {
    class: [...Lara.dialog.footer.class, "!justify-end"],
  },
};

export const BADGE_COLOR_CLASSES: Record<BadgeState, string> = {
  loading: "!bg-gray-500",
  error: "!bg-gray-500",
  pending: "!bg-warning-900",
  added: "!bg-success-800",
  archived: "!bg-gray-500",
};
